import { render, staticRenderFns } from "./BookersTable.vue?vue&type=template&id=676f52dc&scoped=true"
import script from "./BookersTable.vue?vue&type=script&lang=ts"
export * from "./BookersTable.vue?vue&type=script&lang=ts"
import style0 from "./BookersTable.vue?vue&type=style&index=0&id=676f52dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676f52dc",
  null
  
)

export default component.exports